package common

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 24.10.22
 * Author : marcusspors
 */
enum class EEnvironmentVariables(val mVariableName: String, val mDefault: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    VEEUZE_HOST("VEEUZE_HOST", "wrk.prd.dawdigital.com"),

    DEEPLINK_SUBDOMAIN("DEEPLINK_SUBDOMAIN", "farbraum.farbraum.alpina-farben.de"),

    TITLE_TAG("TITLE_TAG", "DEV - DAW Wohny");


    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}